import { Reveal } from "./motion";
import { LeafMark } from "./LeafMark";

// Shared inner-page hero — keeps every route on the same editorial rhythm.
export const PageHero = ({ eyebrow, title, intro, children, testid }) => (
    <section data-testid={testid} className="pt-32 sm:pt-40 pb-14 sm:pb-20 relative overflow-hidden">
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-32 -right-32 w-[540px] h-[540px] rounded-full bg-sage/60 blur-3xl"
        />
        <div className="container-site relative">
            <Reveal>
                <p className="eyebrow text-moss flex items-center gap-2.5">
                    <LeafMark className="w-4 h-4 text-natural" />
                    {eyebrow}
                </p>
            </Reveal>
            <Reveal delay={0.08}>
                <h1 className="font-serif font-medium text-[2.6rem] sm:text-6xl lg:text-[4.2rem] leading-[1.04] tracking-tight mt-6 max-w-4xl">
                    {title}
                </h1>
            </Reveal>
            {intro && (
                <Reveal delay={0.16}>
                    <p className="mt-7 text-base sm:text-lg leading-relaxed text-moss max-w-2xl">
                        {intro}
                    </p>
                </Reveal>
            )}
            {children}
        </div>
    </section>
);
